module.exports = __webpack_public_path__ + "static/media/400140_02.66d973af.png";